/**
 * Notifications store.
 *
 */

import { Module, VuexModule, getModule, Action, Mutation } from 'vuex-module-decorators';
import store from '@/store';

import { withoutElement } from '@/utils/array';

import { Notification, NotificationBody } from '@/components/notification/types';

export const MODULE_NAME = 'notifications';

const AUTOCLOSE_TIME = 3000;

let id = 1;

const createNotification = (body: NotificationBody): Notification => ({
    ...body,
    id: id++,
})

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class NotificationsModule extends VuexModule {
    notifications: Notification[] = [];

    @Mutation
    private add(notification: Notification) {
        this.notifications.push(notification);
    }

    @Mutation
    public remove(notification: Notification) {
        this.notifications = withoutElement(this.notifications, notification);
    }

    @Action({ rawError: true })
    public showWithTimeout(body: NotificationBody, timeout = AUTOCLOSE_TIME) {
        const notification = createNotification(body);

        this.add(notification);

        setTimeout(() => {
            this.remove(notification);
        }, timeout)
    }
}

export default getModule(NotificationsModule);
